import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Search = ({ searchValue }) => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [searchProduct, setSearchProduct] = useState([]);

  const getApi = () => {
    axios
      .get("https://bestdealelectricalsbackend.onrender.com/bestdealelectricals/products")
      .then((res) => {
        setData(res.data.Products);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  useEffect(() => {
    getApi();
  }, []);

  useEffect(() => {
    if (!searchValue || searchValue.trim().length === 0) {
      setSearchProduct([]);
      return;
    }

    const filtered = data.filter((item) =>
      item.title.toLowerCase().includes(searchValue.toLowerCase())
    );
    setSearchProduct(filtered);
  }, [searchValue, data]);

  return (
    <>
      {searchProduct.length > 0 && (
        <section className="search-section col-12 col-sm-8 col-md-6 col-lg-4">
          {searchProduct.map((items) => (
            <div
              key={items._id}
              className="d-flex border search-product my-2 p-2"
              onClick={() => navigate(`/detailPage/${items._id}`)}
            >
              <div className="col-2 d-flex justify-content-center align-items-center">
                <img src={items.image} className="w-100" alt={items.title} />
              </div>
              <div className="col-8 d-flex justify-content-center align-items-center">
                <strong className="text-center">{items.title}</strong>
              </div>
            </div>
          ))}
        </section>
      )}
    </>
  );
};

export default Search;